import React, { SVGProps } from 'react';

export const AffiliatesIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 24,
  height = 24,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 24 24"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M18.98 9.253C18.602 8.29502 18.0312 7.42489 17.303 6.69658C16.5749 5.96826 15.7049 5.39727 14.747 5.019C14.5208 5.27576 14.3402 5.56933 14.213 5.887C15.1086 6.21257 15.9219 6.7305 16.5957 7.40431C17.2695 8.07811 17.7874 8.89143 18.113 9.787C18.4307 9.6598 18.7242 9.4792 18.981 9.253M12.229 5.503L12 5.5C10.7047 5.5 9.43896 5.88699 8.36513 6.61133C7.2913 7.33568 6.45837 8.36433 5.9732 9.56532C5.48803 10.7663 5.37275 12.0849 5.64214 13.3518C5.91153 14.6188 6.55331 15.7764 7.48514 16.6761C8.41698 17.5758 9.59637 18.1766 10.872 18.4014C12.1476 18.6262 13.4613 18.4647 14.6446 17.9377C15.8278 17.4107 16.8266 16.5422 17.5129 15.4436C18.1991 14.345 18.5414 13.0665 18.496 11.772C18.84 11.664 19.1653 11.5223 19.472 11.347C19.49 11.5623 19.4993 11.78 19.5 12C19.4999 13.5112 19.0433 14.9871 18.19 16.2343C17.3367 17.4816 16.1266 18.442 14.7181 18.9896C13.3097 19.5373 11.7686 19.6467 10.2969 19.3036C8.82517 18.9604 7.49145 18.1807 6.47049 17.0665C5.44953 15.9524 4.78895 14.5558 4.57532 13.0598C4.36169 11.5637 4.60498 10.0381 5.27329 8.68269C5.94161 7.32731 7.00378 6.20543 8.32062 5.46407C9.63746 4.7227 11.1476 4.39642 12.653 4.528C12.477 4.83728 12.3345 5.16447 12.228 5.504"
        fill="#CECECE"
        fillRule="evenodd"
      />
      <path
        d="M17 10C18.6569 10 20 8.65685 20 7C20 5.34315 18.6569 4 17 4C15.3431 4 14 5.34315 14 7C14 8.65685 15.3431 10 17 10Z"
        fill="#CECECE"
      />
    </svg>
  );
};
